module.exports = __webpack_public_path__ + "media/images/login-bg-2e713796fd70cef3fcaad8d575c8cff3.png";